import { gql } from '@provision/graphql-client';
import { PLATFORM_FIELDS } from 'src/graphql';

export const BLOCKED_EMAIL_FRAGMENT = gql`
  fragment BlockedEmailFields on BlockedEmail {
    id
    blockedEmailId
    blockedEmail
    partnerId
    createdAt
    updatedAt
    createdByPlatformUserId
  }
`;

export const BLOCKED_EMAIL_RELATIONS = gql`
  fragment BlockedEmailRelations on BlockedEmail {
    id
    createdByPlatformUser {
      ...PlatformUserFields
    }
  }
  ${PLATFORM_FIELDS}
`;
